import LSystem from './LSystem';

type StackFrame = {
    production: string;
    position: number;
};

type Next = {
    symbol: string;
    levelStart: number;
    levelEnd: number;
};

const newFrame = (production: string): StackFrame => {
    return { production, position: 0 };
};

class Visitor {
    lsystem: LSystem;
    maxLevel: number;

    stack: StackFrame[];

    constructor(lsystem: LSystem, maxLevel: number) {
        this.lsystem = lsystem;
        this.maxLevel = maxLevel;

        this.stack = [newFrame(this.lsystem.getAxiom())];
    }

    nextVal(): Next | false {
        let next = this.next();
        while (next === true) {
            next = this.next();
        }
        return next;
    }

    next(): Next | boolean {
        if (this.stack.length === 0) {
            return false;
        }

        const currentLevel = this.stack.length - 1;
        const frame = this.stack[currentLevel];
        const production = frame.production;
        const position = frame.position;

        if (position >= production.length) {
            this.stack.pop();
            return true; // let the caller know there is more to do.
        }

        const symbol = production[position];
        frame.position += 1;

        const nextProduction = this.lsystem.getRule(symbol);
        if (nextProduction && currentLevel !== this.maxLevel) {
            this.stack.push(newFrame(nextProduction));
        }

        //control whether we emit this for just the current level
        //or all levels.
        const currentLevelOnly = !!nextProduction;
        const levelEnd = currentLevelOnly ? currentLevel : this.maxLevel;
        return { symbol, levelStart: currentLevel, levelEnd };
    }
}

export default Visitor;
